<template>
    <div>
        <component
            v-if="actionComponent"
            :is="actionComponent"
            :action="item"
        />
    </div>
</template>

<script>
import TextActionResult from "./ActionsResults/TextActionResult";
import FileActionResult from "./ActionsResults/FileActionResult";
import PhotoActionResult from "./ActionsResults/PhotoActionResult";
import DateActionResult from "./ActionsResults/DateActionResult";
import SignActionResult from "./ActionsResults/SignActionResult";
import GetSurveyActionResult from "./ActionsResults/GetSurveyActionResult";

export default {
    name: "action-result",
    props: {
        item: Object,
        field: Object,
    },
    computed: {
        actionComponent() {
            switch (this.item.actionType) {
                case 0:
                    return TextActionResult;
                case 1:
                    return FileActionResult;
                case 2:
                    return PhotoActionResult;
                case 3:
                    return DateActionResult;
                case 4:
                    return SignActionResult;
                case 5:
                    return GetSurveyActionResult;
            }
            return null;
        },
    },
};
</script>